import { useState, useEffect } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Autocomplete, Box, CircularProgress, Typography } from '@mui/material';
import { globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { checkApiStatus, numberWithCommas } from '../../../../utils'
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { updatecashNonCashApi, addcashNonCashApi } from '../apiService';
import moment from 'moment';
import { regexConstants } from '../../../../constants/regEx';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { AttachementsUpload } from '../../../../shared_elements/components';
import { backendDateFormat, fieldDateFormat } from '../../../../constants';
import { PageLoader } from '../../../../shared_elements';
import { getConstantTypesApi } from '../../../../shared_elements/actionCreators';
import { trackActivity } from '../../../../utils/mixpanel';
import { formatBytes } from '../../../../utils/fileUpload';
import { setFileUploadDetails } from '../../../../shared_elements/actions';
const NonCashTxnCRU = ({ fileUpload,txnCRU, modeType, getResponseBack, onToggleModal, securitydata, onOpenAttachments,getSortingWiseData,sortInfo, sdcData  }) => {
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug }
    const { storageDetails } = useSelector((state) => state.leases); 
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar();
    const [data, setData] = useState(txnCRU?.data || {});
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState({});
    const [cleared, setCleared] = useState(false);
    const [attachments, setAttachments] = useState([]);
    const { leaseBasicDetails, constantTypes } = useSelector((state) => state.leases);

    useEffect(() => {
        if (!sdcData?.base_currency) {
            setData((prev) => ({
                ...prev,
                base_amount: null
            }));
        }
    }, [sdcData?.base_currency]);

    useEffect(() => {
        dispatch(getConstantTypesApi({ constant_types: ['security_deposit_credit_transaction_status'] }));
        if (cleared) {
            const timeout = setTimeout(() => {
                setCleared(false);
            }, 1500);
            return () => clearTimeout(timeout);
        }
        return () => { };
    }, [])

    const onFieldChange = (keyParam, value) => {
        setData({ ...data, [keyParam]: value });
    }
    const handleFileChange = (files) => {
        setAttachments(files);
        dispatch(setFileUploadDetails({attachments:files}))
    };

    const onRestErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }

    const onAddEditSecurityDeposit = () => {
        let validationInputs = {};
        validationInputs = {
            reference_number: data?.reference_number?.trim() ? "" : "Please enter Reference Number",
            contractual_amount: data?.contractual_amount ? "" : "Please enter Contractual Amount",
        };
        const issuedate = moment(data?.issue_date);
        const validityStartDate = moment(data?.validity_start_date);
        const validityEndDate = moment(data?.validity_end_date);
        if (data.issue_date && !issuedate.isValid()) {
            validationInputs.issue_date = "Please enter valid Issue Date"
        }
        if(data.validity_start_date && !validityStartDate.isValid()) {
            validationInputs.validity_start_date = "Please eneter valid Start Date"
        }
        if(data.validity_end_date && !validityEndDate.isValid()) {
            validationInputs.validity_end_date = "Please eneter valid End Date"
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            let payload = Object.assign({}, data);
            payload = {
                ...data,
                base_amount: sdcData?.base_currency ? data?.base_amount : null,
            };
            if (data?.id) {
                globalPutService(updatecashNonCashApi({ ...params, slug: securitydata?.slug, txnSlug: data?.slug }), payload)
                    .then((response) => {
                        if (checkApiStatus(response)) {
                            if (attachments?.length) {
                                fileUpload(data?.slug,"nonTxn",'updated')
                            }
                            if (sortInfo[securitydata?.slug]?.sort) {
                                getSortingWiseData(sortInfo[securitydata?.slug], securitydata?.slug)
                            }
                            setLoading(false);
                            onToggleModal();
                            getResponseBack();
                            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit NonCash Txn`, success_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                        } else {
                            setLoading(false);
                            enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit NonCash Txn`, error_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                        }
                    })
            } else {
                globalPostService(addcashNonCashApi({ ...params, slug: securitydata?.slug }), payload).then((response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                          fileUpload(response?.data?.data?.slug,"nonTxn",'created')
                        }
                        if (sortInfo[securitydata?.slug]?.sort) {
                            getSortingWiseData(sortInfo[securitydata?.slug], securitydata?.slug)
                        }
                        setLoading(false);
                        onToggleModal();
                        getResponseBack();
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add NonCash Txn`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add NonCash Txn`, error_msg: response?.data?.message, item_id: null, payload: data, response: response?.data })
                    }
                })
            }
        } else {
            setError(validationInputs)
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} NonCash Txn`, error_msg: validationInputs, })
        }
    }
   
const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Security Deposit ${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} NonCash Txn`, page_type: page_type, })
    }

    return (
        <>
            <Dialog
                aria-labelledby="customized-dialog-title"
                maxWidth="md"
                fullWidth
                open={true}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} style={{ position: 'sticky' }} className='dialog-header'>
                    <Typography sx={{ marginLeft: '10px' }}>
                        {modeType === "add" ? "Add Non Cash Txn" : modeType === "edit" ? "Edit Non Cash Txn" : "View Non Cash Txn"}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                required
                                id="reference_number"
                                label="Reference Number"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                error={error?.reference_number || false}
                                helperText={error?.reference_number || ''}
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={data?.reference_number || ""}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    return regexConstants.restrictUnicodeCharacters.test(value) || value === "" ? value?.length <= 50 ? onFieldChange("reference_number", value.trimStart()) : e.preventDefault() : null
                                }}
                                onFocus={() => onRestErrorKey("reference_number")}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="type_of_financial_instrument"
                                label="Type of Financial Instrument"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={data?.type_of_financial_instrument || ""}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    return regexConstants.restrictUnicodeCharacters.test(value) || value === "" ? value?.length <= 50 ? onFieldChange("type_of_financial_instrument", value.trimStart()) : e.preventDefault() : null
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="on_behalf_of"
                                label="On Behalf of"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={data?.on_behalf_of || ""}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    return regexConstants.restrictUnicodeCharacters.test(value) || value === "" ? value?.length <= 50 ? onFieldChange("on_behalf_of", value.trimStart()) : e.preventDefault() : null
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="issuing_party"
                                label="Issuing Party"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={data?.issuing_party || ""}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    return regexConstants.restrictUnicodeCharacters.test(value) || value === "" ? value?.length <= 50 ? onFieldChange("issuing_party", value.trimStart()) : e.preventDefault() : null
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="reference_amount"
                                label="Confirming Party"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={data?.confirming_party || ""}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    return regexConstants.restrictUnicodeCharacters.test(value) || value === "" ? value?.length <= 50 ? onFieldChange("confirming_party", value.trimStart()) : e.preventDefault() : null
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                required
                                id="contractual_amount"
                                label="Contractual Amount"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                error={error?.contractual_amount || false}
                                helperText={error?.contractual_amount || ''}
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={modeType === "view" && data?.contractual_amount !== '' && data?.contractual_amount !== null && data?.contractual_amount !== undefined ? numberWithCommas(data?.contractual_amount) : (data?.contractual_amount || "")}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (val === "") {
                                        onFieldChange("contractual_amount", null);
                                    } else if (val.length <= 20 && regexConstants.decimalnodotstart.test(val)) {
                                        onFieldChange("contractual_amount", val);
                                    }
                                }}
                                onFocus={() => onRestErrorKey("contractual_amount")}
                            />
                        </Grid>
                        {sdcData?.base_currency && 
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="base_amount"
                                label="Base Amount"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={modeType === "view" && data?.base_amount !== '' && data?.base_amount !== null && data?.base_amount !== undefined ? numberWithCommas(data?.base_amount) : (data?.base_amount || "")}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (val === "") {
                                        onFieldChange("base_amount", null);
                                        return;
                                    } else if (val.length <= 20 && regexConstants.decimalnodotstart.test(val)) {
                                        onFieldChange("base_amount", val);
                                    }
                                }}
                            />
                        </Grid>}
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Issue Date"
                                    minDate={moment(leaseBasicDetails?.start_date)}
                                    maxDate={moment(leaseBasicDetails?.end_date)}
                                    value={data?.issue_date ? moment(data?.issue_date) : null}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        onFieldChange("issue_date", data ? moment(data).format(backendDateFormat) : null);
                                        if (isValid) {
                                            onRestErrorKey("issue_date");
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.issue_date || false,
                                            helperText: error.issue_date || '',
                                            onFocus: () => {error.issue_date && onRestErrorKey("issue_date");}
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => { onFieldChange("issue_date", null); setCleared(true); onRestErrorKey("issue_date") }
                                        },
                                    }}
                                    shouldDisableDate={(date) => date.isBefore(moment(leaseBasicDetails?.start_date), 'day') || date.isAfter(moment(leaseBasicDetails?.end_date), 'day')}
                                    shouldDisableMonth={(month) => { const y = month.year(), m = month.month(), s = moment(leaseBasicDetails?.start_date), e = moment(leaseBasicDetails?.end_date); return y < s.year() || y > e.year() || (y === s.year() && m < s.month()) || (y === e.year() && m > e.month()); }}
                                    shouldDisableYear={(year) => { const y = year.year(), s = moment(leaseBasicDetails?.start_date), e = moment(leaseBasicDetails?.end_date); return y < s.year() || y > e.year(); }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />

                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                options={constantTypes
                                    || []}
                                getOptionLabel={(option) => option?.label || ""}
                                disabled={modeType === 'view'}
                                value={data?.status || null}
                                onFocus={() => onRestErrorKey("status")}
                                onChange={(e, value) => onFieldChange("status", value)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Status"
                                        margin='normal'
                                        size='small'
                                        slotProps={{ inputLabel: { shrink: true } }}
                                        disabled={modeType === 'view'}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="pledged"
                                label="Pledge"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={data?.pledged || ""}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    return regexConstants.restrictUnicodeCharacters.test(value) || value === "" ? value?.length <= 50 ? onFieldChange("pledged", value.trimStart()) : e.preventDefault() : null
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="beneficiary"
                                label="Beneficiary"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={data?.beneficiary || ""}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    return regexConstants.restrictUnicodeCharacters.test(value) || value === "" ? value?.length <= 50 ? onFieldChange("beneficiary", value.trimStart()) : e.preventDefault() : null
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="original_loc_location"
                                label="Original LOC Location"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={data?.original_loc_location || ""}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    return !regexConstants.restrictUnicodeCharacters.test(value) && value !== "" ? null : value.length <= 50 ? onFieldChange("original_loc_location", value.trimStart()) : null;
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="confirming_loc_location"
                                label="Confirming LOC Location"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={data?.confirming_loc_location || ""}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    return !regexConstants.restrictUnicodeCharacters.test(value) && value !== "" ? null : value.length <= 50 ? onFieldChange("confirming_loc_location", value.trimStart()) : null;
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="issuing_bank"
                                label="Issuing Bank"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={data?.issuing_bank || ""}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    return !regexConstants.restrictUnicodeCharacters.test(value) && value !== "" ? null : value.length <= 50 ? onFieldChange("issuing_bank", value.trimStart()) : null;
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="issuing_bank_reference"
                                label="Issuing Bank Reference"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={data?.issuing_bank_reference || ""}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    return !regexConstants.restrictUnicodeCharacters.test(value) && value !== "" ? null : value.length <= 50 ? onFieldChange("issuing_bank_reference", value.trimStart()) : null;
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="confirming_bank"
                                label="Confirming Bank"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={data?.confirming_bank || ""}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    return !regexConstants.restrictUnicodeCharacters.test(value) && value !== "" ? null : value.length <= 50 ? onFieldChange("confirming_bank", value.trimStart()) : null;
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="advising_bank"
                                label="Advising Bank"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={data?.advising_bank || ""}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    return !regexConstants.restrictUnicodeCharacters.test(value) && value !== "" ? null : value.length <= 50 ? onFieldChange("advising_bank", value.trimStart()) : null;
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Validity Start Date"
                                    // Active
                                    minDate={moment(leaseBasicDetails?.start_date)}
                                    maxDate={moment(leaseBasicDetails?.end_date)}
                                    value={data?.validity_start_date ? moment(data?.validity_start_date) : null}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        onFieldChange("validity_start_date", data ? moment(data).format(backendDateFormat) : null);
                                        if (isValid) {
                                            onRestErrorKey("validity_start_date");
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.validity_start_date || false,
                                            helperText: error.validity_start_date || '',
                                            onFocus: () => {error.validity_start_date && onRestErrorKey("validity_start_date");}
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => { onFieldChange("validity_start_date", null); setCleared(true); onRestErrorKey("validity_start_date") }
                                        },
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Validity End Date"
                                    // minDate={moment(leaseBasicDetails?.start_date)}
                                    minDate={data?.validity_end_date ? moment(data.validity_end_date) : null}
                                    maxDate={moment(leaseBasicDetails?.end_date)}
                                    value={data?.validity_end_date ? moment(data?.validity_end_date) : null}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        onFieldChange("validity_end_date", data ? moment(data).format(backendDateFormat) : null);
                                        if (isValid) {
                                            onRestErrorKey("validity_end_date");
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.validity_end_date || false,
                                            helperText: error.validity_end_date || '',
                                            onFocus: () => {error.validity_end_date && onRestErrorKey("validity_end_date");}
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => { onFieldChange("validity_end_date", null); setCleared(true); onRestErrorKey("validity_end_date") }
                                        },
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    disabled={modeType === 'view'}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="purpose_of_instrument"
                                label="Purpose of Instrument"
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                disabled={modeType === "view"}
                                slotProps={{ inputLabel: { shrink: true } }}
                                value={data?.purpose_of_instrument || ""}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    return !regexConstants.restrictUnicodeCharacters.test(value) && value !== "" ? null : value.length <= 50 ? onFieldChange("purpose_of_instrument", value.trimStart()) : null;
                                }}
                            />
                        </Grid>
                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>
                            <Box className="responsive-buttons">
                            {data?.id && data?.attachments?.length ? <Button onClick={() => { onOpenAttachments(2); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>({txnCRU?.data?.attachments?.length})Attachment(s)</Button> : null}
                               <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                          </Box>
                            {modeType === 'view' ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={data?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className='cancel-btn' variant="outlined" disabled={isLoading} size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }} >{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null : <Button variant="contained" size='small' className="btn-primary" onClick={() => { handleItemClicked('Save Button'); onAddEditSecurityDeposit() }}>{isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"}</Button>}
                </DialogActions>
            </Dialog>
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default NonCashTxnCRU